import type { components as StrapiComponents } from '@core/types/clients/strapi'
import { toValue, useCoreConfig, useQuery, useStrapi, type MaybeRefOrGetter } from '#imports'

export const useStrapiPage = (seoName: MaybeRefOrGetter<string | undefined>) => {
    const { site } = useCoreConfig()
    const client = useStrapi()

    return useQuery(async () => {
        const { data } = await client.GET('/pages/{seoName}', {
            params: {
                path: {
                    seoName: toValue(seoName)!,
                },
                query: {
                    brand: site.brand
                }
            },
        })
        return data as StrapiComponents['schemas']['Page']
    }, {
        key: () => `strapi:page-${(toValue(seoName))}`,
        enabled: () => !!toValue(seoName),
    })
}
